export default __webpack_public_path__ + "static/media/profile-icon-2.9e4e97d9.svg";